// extracted by mini-css-extract-plugin
module.exports = {"main":"utils_main__ZPdp1","headingLg":"utils_headingLg__2fvot","headingMd":"utils_headingMd__1JF2P","icon":"utils_icon__2eeVg","btn":"utils_btn__246OY"};